// Material
import { Divider } from '@mui/material'
// Logic
import {
  useHallNonAdminSubscribers,
  useSearchedHallNonAdminSubscribers,
} from '$logic/subscription/react-hook'
// Common
import {
  UserListItemSkeleton,
  UserListItemWithStatus,
} from '$common/user-list-item'
import { withSearchableInfiniteListPage } from '$common/searchable-list-page'
// Localization
import { t } from '$i18n'
import { EmptyStateList } from '$common/empty-state-list'
import { closeHallRemoveMember } from '$logic/router'
import { showBanUserConfirmModal } from '$comp/modals/confirmation-dialog'

function ListItem({ id, roomId }: { id: string; roomId: string }) {
  return (
    <>
      <UserListItemWithStatus
        userId={id}
        hasDivider={false}
        onClick={() => showBanUserConfirmModal(roomId, id)}
      />
      <Divider variant="inset" />
    </>
  )
}

const Page = withSearchableInfiniteListPage<
  { id: string },
  string,
  { query: string; fetchedItems: { id: string }[]; hasMoreItemToLoad: boolean }
>({
  appBarTitle: t('profile.hall.removeUsers.title'),
  SkeletonItem: UserListItemSkeleton,
  EmptyStateComponent: () => <EmptyStateList />,
  fetchHook: useHallNonAdminSubscribers, // TODO: All users can be deleted if the clientUser is the owner. Thus, the fetch hook should be changed.
  searchHook: useSearchedHallNonAdminSubscribers,
  onBack: closeHallRemoveMember,
})

export function RemoveMembers({ roomId }: { roomId: string }) {
  return (
    <Page
      fetchHookParams={roomId}
      getSearchHookParams={(query, items, hasMoreItemToLoad) => ({
        query,
        fetchedItems: items,
        hasMoreItemToLoad,
        roomId,
      })}
      ListItem={item => <ListItem {...item} roomId={roomId} />}
    />
  )
}
